<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>Semen and Embryo Analytics</h2>
        <v-spacer></v-spacer>
        <v-select
          :items="category"
          color="primary"
          dense
          outlined
          item-text="text"
          item-value="value"
          @input="changedLabel"
          v-model="categories"
          class="shrink mr-2 wdt"
          placeholder="Select By category"
        ></v-select>
      </div>
      <div class="d-flex">
        <v-select
          dense
          outlined
          class="shrink mr-2 wdt"
          placeholder="Calendar Filter"
          append-icon="mdi-filter-outline"
        >
          <!-- <v-icon>mdi-filter-outline</v-icon> -->
        </v-select>
        <!-- <v-select
              dense
              outlined
              class="shrink mr-2 wdt"
              placeholder="Farm/Herd"
               append-icon="mdi-filter-outline"
            ></v-select> -->
        <v-autocomplete
          v-model="farm"
          :items="farmsList"
          item-text="name"
          item-value="farmNumber"
          dense
          append-icon="mdi-filter-outline"
          :loading="farmLoading"
          :search-input.sync="farmSearch"
          outlined
          hide-no-data
          placeholder="Farm/Herd"
          class="shrink mr-2 wdt"
        ></v-autocomplete>
        <v-autocomplete
          v-model="owner"
          :items="userList"
          item-text="name"
          item-value="userNumber"
          dense
          append-icon="mdi-filter-outline"
          :loading="userLoading"
          :search-input.sync="userSearch"
          outlined
          hide-no-data
          placeholder="owner"
          class="shrink mr-2 wdt"
        ></v-autocomplete>
        <!-- <v-select
              dense
              outlined
              class="shrink mr-2 wdt"
              v-model="region"
              placeholder="Owner"
               append-icon="mdi-filter-outline"
            ></v-select> -->
        <v-btn
          type="submit"
          width="146"
          height="39"
          color="primary"
          @click="getCalvedata()"
          >Apply</v-btn
        >
        <v-btn
          width="146"
          height="39"
          class="ml-2"
          outlined
          color="primary"
          exact
          @click="cancelData()"
          > {{ $t("cancel") }}</v-btn
        >
      </div>
      <v-card flat elevation="0" class="px-2 py-2" outlined>
        <v-toolbar dense flat :elevation="0">
          <v-toolbar-title class="text-h6 font-weight-black"
            >Semen Production</v-toolbar-title
          >
          <v-spacer></v-spacer>

          <span class="mt-5 mr-2">
            <v-menu
              v-model="startmenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDate"
                  class="shrink"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                @input="startmenu = false"
              ></v-date-picker>
            </v-menu>
          </span>
          <v-btn color="primary" dark @click="updateChart()" class="ml-2 mb-2">
            Apply
          </v-btn>
          <v-icon color="primary" dark @click="getCalvedaily()" class="ml-2"
            >mdi-reload</v-icon
          >
          <v-icon class="float-right">mdi-dots-vertical</v-icon>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-card flat>
            <v-card-title>
              <v-row class="elevation-0" width="100%">
                <v-col sm="" class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-h5 mt-2 mb-2 text-capitalize"
                        >
                          {{ calf.lastYearReg }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="mb-2">
                          <v-icon
                            small
                            color="primary"
                            v-if="calf.lastYearPer >= 50"
                            >mdi-arrow-up</v-icon
                          >
                          <v-icon small color="red" v-else
                            >mdi-arrow-down</v-icon
                          >
                          {{ calf.lastYearPer ? calf.lastYearPer : "0" }} %
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="font-weight-medium">
                          {{ "Since Last Year" }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col sm="" class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-h5 mt-2 mb-2 text-capitalize"
                        >
                          {{ calf.lastQuaterReg }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="mb-2">
                          <v-icon
                            small
                            color="primary"
                            v-if="calf.lastQuaterPer >= 50"
                            >mdi-arrow-up</v-icon
                          >
                          <v-icon small color="red" v-else
                            >mdi-arrow-down</v-icon
                          >
                          {{ calf.lastQuaterPer ? calf.lastQuaterPer : "0" }}%
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="font-weight-medium">
                          {{ "Since Last Quarter" }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col sm="" class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-h5 mt-2 mb-2 text-capitalize"
                        >
                          {{ calf.lastMonthReg }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="mb-2">
                          <v-icon
                            small
                            color="primary"
                            v-if="calf.lastMonthPer >= 50"
                            >mdi-arrow-up</v-icon
                          >
                          <v-icon small color="red" v-else
                            >mdi-arrow-down</v-icon
                          >
                          {{ calf.lastMonthPer ? calf.lastMonthPer : "0" }}%
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="font-weight-medium">
                          {{ "Since Last Month" }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col sm="" class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-h5 mt-2 mb-2 text-capitalize"
                        >
                          {{ calf.lastWeekReg }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="mb-2">
                          <v-icon
                            small
                            color="primary"
                            v-if="calf.lastWeekPer >= 50"
                            >mdi-arrow-up</v-icon
                          >
                          <v-icon small color="red" v-else
                            >mdi-arrow-down</v-icon
                          >
                          {{ calf.lastWeekPer ? calf.lastWeekPer : "0" }}%
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="font-weight-medium">
                          {{ "Since Last Week" }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-card-text>
      </v-card>
      <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined>
        <v-toolbar dense flat :elevation="0">
          <v-toolbar-title class="text-h6 font-weight-black"
            >Semen Production</v-toolbar-title
          >
          <v-spacer></v-spacer>

          <span class="mt-5 mr-2">
            <v-menu
              v-model="startmenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDate"
                  class="shrink"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                @input="startmenu = false"
              ></v-date-picker>
            </v-menu>
          </span>
          
          <v-btn color="primary" dark @click="updateChart()" class="ml-2 mb-2">
            Apply
          </v-btn>
          <v-icon color="primary" dark @click="getCalvedaily()" class="ml-2"
            >mdi-reload</v-icon
          >
          <v-icon class="float-right">mdi-dots-vertical</v-icon>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="mt-5 pa-0">
          <template>
            <bar-chart
              v-if="loaded"
              :chartdata="chartData"
              :options="options"
            ></bar-chart>
                      <v-card v-else class="px-5 mt-5">
              <v-card-text class="text-center">
                <v-avatar size="135"> </v-avatar>
                <p class="text-h4 font-weight-bold">No Record Found</p>
                <p>No Animals are Registered for this Farm</p>
              </v-card-text>
            </v-card>
          </template>
        </v-card-text>
      </v-card>
      <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined>
        <v-toolbar dense flat :elevation="0">
          <v-toolbar-title class="text-h6 font-weight-black"
            >Embryo Production</v-toolbar-title
          >
          <v-spacer></v-spacer>

          <span class="mt-5 mr-2">
            <v-menu
              v-model="startmenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDate"
                  class="shrink"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                @input="startmenu = false"
              ></v-date-picker>
            </v-menu>
          </span>
          <v-btn color="primary" dark @click="updateChart()" class="ml-2 mb-2">
            Apply
          </v-btn>
          <v-icon color="primary" dark @click="getCalvedaily()" class="ml-2"
            >mdi-reload</v-icon
          >
          <v-icon class="float-right">mdi-dots-vertical</v-icon>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-card flat>
            <v-card-title>
              <v-row class="elevation-0" width="100%">
                <v-col sm="" class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-h5 mt-2 mb-2 text-capitalize"
                        >
                          {{ calf.lastYearReg }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="mb-2">
                          <v-icon
                            small
                            color="primary"
                            v-if="calf.lastYearPer >= 50"
                            >mdi-arrow-up</v-icon
                          >
                          <v-icon small color="red" v-else
                            >mdi-arrow-down</v-icon
                          >
                          {{ calf.lastYearPer ? calf.lastYearPer : "0" }} %
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="font-weight-medium">
                          {{ "Since Last Year" }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col sm="" class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-h5 mt-2 mb-2 text-capitalize"
                        >
                          {{ calf.lastQuaterReg }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="mb-2">
                          <v-icon
                            small
                            color="primary"
                            v-if="calf.lastQuaterPer >= 50"
                            >mdi-arrow-up</v-icon
                          >
                          <v-icon small color="red" v-else
                            >mdi-arrow-down</v-icon
                          >
                          {{ calf.lastQuaterPer ? calf.lastQuaterPer : "0" }}%
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="font-weight-medium">
                          {{ "Since Last Quarter" }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col sm="" class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-h5 mt-2 mb-2 text-capitalize"
                        >
                          {{ calf.lastMonthReg }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="mb-2">
                          <v-icon
                            small
                            color="primary"
                            v-if="calf.lastMonthPer >= 50"
                            >mdi-arrow-up</v-icon
                          >
                          <v-icon small color="red" v-else
                            >mdi-arrow-down</v-icon
                          >
                          {{ calf.lastMonthPer ? calf.lastMonthPer : "0" }}%
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="font-weight-medium">
                          {{ "Since Last Month" }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col sm="" class="">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-h5 mt-2 mb-2 text-capitalize"
                        >
                          {{ calf.lastWeekReg }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="mb-2">
                          <v-icon
                            small
                            color="primary"
                            v-if="calf.lastWeekPer >= 50"
                            >mdi-arrow-up</v-icon
                          >
                          <v-icon small color="red" v-else
                            >mdi-arrow-down</v-icon
                          >
                          {{ calf.lastWeekPer ? calf.lastWeekPer : "0" }}%
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="font-weight-medium">
                          {{ "Since Last Week" }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-card-text>
      </v-card>
      <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined>
        <v-toolbar dense flat :elevation="0">
          <v-toolbar-title class="text-h6 font-weight-black"
            >Embryo Production</v-toolbar-title
          >
          <v-spacer></v-spacer>

          <span class="mt-5 mr-2">
            <v-menu
              v-model="startmenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDate"
                  class="shrink"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                @input="startmenu = false"
              ></v-date-picker>
            </v-menu>
          </span>
          
          <v-btn color="primary" dark @click="updateChart()" class="ml-2 mb-2">
            Apply
          </v-btn>
          <v-icon color="primary" dark @click="getCalvedaily()" class="ml-2"
            >mdi-reload</v-icon
          >
          <v-icon class="float-right">mdi-dots-vertical</v-icon>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="mt-5 pa-0">
          <template>
            <bar-chart
              v-if="loaded"
              :chartdata="chartData"
              :options="options"
            ></bar-chart>
                      <v-card v-else class="px-5 mt-5">
              <v-card-text class="text-center">
                <v-avatar size="135"> </v-avatar>
                <p class="text-h4 font-weight-bold">No Record Found</p>
                <p>No Animals are Registered for this Farm</p>
              </v-card-text>
            </v-card>
          </template>
        </v-card-text>
      </v-card>
      <v-row>
      <v-col>
      <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined>
        <v-toolbar dense flat :elevation="0">
          <v-toolbar-title class="text-h6 font-weight-black"
            >Semen</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-icon color="primary" dark class="ml-2" @click="getCalveweekly()" >mdi-reload</v-icon>
          <v-icon class="float-right">mdi-dots-vertical</v-icon>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="mt-5 pa-0">
          <template>
            <line-chart v-if="loadedWeek" :chartdata="data" :options="lineoptions"></line-chart>
                   <v-card v-else class="px-5 mt-5">
              <v-card-text class="text-center">
                <v-avatar size="135"> </v-avatar>
                <p class="text-h4 font-weight-bold">No Record Found</p>
                <p>No Animals are Registered for this Farm</p>
              </v-card-text>
            </v-card>
          </template>
        </v-card-text>
      </v-card>

      </v-col>
      <v-col>
        <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined>
        <v-toolbar dense flat :elevation="0">
          <v-toolbar-title class="text-h6 font-weight-black"
            >Embryo</v-toolbar-title
          >
          <v-spacer></v-spacer>

          <v-icon color="primary" dark class="ml-2" @click="getCalveweekly()" >mdi-reload</v-icon>
          <v-icon class="float-right">mdi-dots-vertical</v-icon>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="mt-5 pa-0">
          <template>
            <line-chart v-if="loadedWeek" :chartdata="data" :options="lineoptions"></line-chart>
                   <v-card v-else class="px-5 mt-5">
              <v-card-text class="text-center">
                <v-avatar size="135"> </v-avatar>
                <p class="text-h4 font-weight-bold">No Record Found</p>
                <p>No Animals are Registered for this Farm</p>
              </v-card-text>
            </v-card>
          </template>
        </v-card-text>
      </v-card>
      </v-col>
      </v-row>
      


      <v-card flat elevation="0" class="mt-5 px-2 py-2" outlined height="">
        <v-card-text class="mt-5 pa-0">
          <v-data-table
            :headers="headers"
            :items="anidata"
            v-model="selected"
            show-select
            item-key="animalNumber"
            :items-per-page="10"
            :loading="loading"
            loading-text="Loading ... Please wait"
            hide-default-footer
            :footer-props="{
              'items-per-page-options': [5, 10, 25],
              'show-first-last-page': true,
              'show-current-page': true,
              'items-per-page-text': 'Farms per page',
            }"
            :options.sync="tableOptions"
            :server-items-length="totalPregnancy"
          >
            <template v-if="anidata.length > 0" v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.animalNumber"
                  style="position: relative; width: 0; height: 0"
                >
                  <td>
                    <v-checkbox
                      multiple
                      v-model="selected"
                      :value="item"
                      style="margin: 0px; padding: 0px"
                      hide-details
                      v-on:click.stop=""
                    />
                  </td>
                  <td>{{ item.animalNumber }}</td>
                  <td>{{ item.pregnancyCheckDate }}</td>
                  <td>{{ item.deliveryDate }}</td>
                  <td>{{ item.rate }}</td>
                  <td>{{ item.pregnanyFrequency }}</td>
                  <td>{{ item.status }}</td>
                  <!-- <div
                    style="position: absolute; right: 10px; top: 4px"
                    v-if="item === selectedItem"
                  >
                  </div> -->
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import HealthReport from "@/_services/AnalyticsService";
import BarChart from "./BarChart.vue";
import LineChart from "./LineChart.vue";
import FarmService from "@/_services/farmService.js";
export default {
  components: {
    BarChart,
    LineChart,
  },
  watch: {
    async farmSearch(val) {
      await this.searchFarm(val);
    },
    async userSearch(val) {
      await this.searchUser(val);
    },
    tableOptions: {
      handler() {
        this.getPregnancyReportData();
      },
      deep: true,
    },
  },
  async mounted() {
    document.title = "Calf Analytics";
    await this.getCalvedata();
    await this.getCalvedaily();
     await this.getCalveweekly();
     await this.getPregnancydaily();
    await this.getPregnancydata();
    await this.getPregnancyweekly();
    // await this.renderChart(this.chartData, this.options)
  },
  data: () => ({
    //   width: 2,
    anidata: [
    ],
    startmenu: false,
    endmenu: false,
    startDate: "2021-11-11",
    endDate: "2022-04-15",
    startmenuWeekly: false,
    endmenuWeekly: false,
    startDateWeekly: "2021-11-11",
    endDateWeekly: "2021-11-17",
    farmLoading: false,
    farmSearch: "",
    farmsList: [],
    userLoading: false,
    userSearch: "",
    search: "",
    userList: [],
    loadedWeek:false,
    owner: "",
    farm: "",
    calf: {},
    result: [],
    chartData: {
      labels: [],
      datasets: [
        {
          label: "This Week",
          backgroundColor: "#489E16",
          data: [],
                        barPercentage: 2,
        barThickness: 7,
        maxBarThickness: 10,
        minBarLength: 2,
        },
        {
          label: "Next Week",
          backgroundColor: "#FFB443",
          data: [],
                        barPercentage: 2,
        barThickness: 7,
        maxBarThickness: 10,
        minBarLength: 2,
        },
      ],
    },
    options: {
      tooltips: {
        displayColors: true,
        callbacks: {
          mode: "x",
        },
      },
      scales: {
        xAxes: [
          {
            // stacked: true,
            gridLines: {
              display: false,
            },
          },
        ],
        yAxes: [
          {
            // stacked: true,
            ticks: {
              beginAtZero: true,
            },
            type: "linear",
          },
        ],
      },
      responsive: true,
      maintainAspectRatio: false,
      legend: { position: "top" },
    },
    data: {
      labels: [],
      datasets: [
        {
          label: "Last Week",
          backgroundColor: "#489E16",
          borderColor: "#489E16",
          fill: false,
          data: [],
        },
        {
          label: "This Week",
          backgroundColor: "#FFB443",
          borderColor: "#FFB443",
          fill: false,
          data: [],
        },
      ],
    },
    headers: [
      {
        text: "Product Name",
        align: "start",
        sortable: false,
        value: "animalNumber",
      },
      { text: "Volume Sold", value: "pregnancyCheckDate" },
      { text: "Record Point", value: "diagnosisName" },
      { text: "In Stock", value: "rate" },
      { text: "Revenue", value: "pregnanyFrequency" },
      { text: "Stock Status", value: "status" },
      // { text: "Recovery Status", value: "recoveryStatus" },
    ],
    lineoptions: {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        display: true,
      },
      scales: {
        xAxes: [
          {
            display: true,
            scaleLabel: {
              display: true,
              // labelString: "Date",
            },
          },
        ],
        yAxes: [
          {
            display: true,
            //type: 'logarithmic',
            scaleLabel: {
              display: true,
              // labelString: "Index Returns",
            },
            ticks: {
              min: 0,
              max: 10,
              // forces step size to be 5 units
              // stepSize: 100
            },
          },
        ],
      },
    },
    categories: "semenAnalytics",
    category: [
      {
        text: "Semen/Embryo",
        value: "semenAnalytics",
      },
      {
        text: "Pregnancy",
        value: "pregnancyAnalytics",
      },
    ],
    breadcrumbs: [
      {
        text: "Dashboard",
        disabled: false,
        to: "/",
      },
      {
        text: "Analytics",
        disabled: true,
      },
      //   {
      //     text: "Breeder Report",
      //     disabled: true,
      //   },
    ],
    selected: [],
    selected1: "",
    loaded: false,
  }),
  methods: {
    changedLabel(event) {
      this.selected1 = event;
      console.log(this.selected1);
      this.$router.push({
        name: `${this.selected1}`,
      });
    },
    async updateWeeklyChart() {
      this.loadedWeek = false;
      console.log(false);
      this.getPregnancyweekly();
    },
    async updatedailyChart() {
      this.loaded = false;
      console.log(false);
      this.getPregnancydaily();
    },
    async updateChart() {
      this.loaded = false;
      console.log(false);
      this.getCalvedaily();
    },
     async updateChartWeek() {
      this.loadedWeek = false;
      console.log(false);
      this.getCalveweekly();
    },
    cancelData(){
      this.owner=""
      this.farm=""
    },
    searchFarm(val) {
      if (val == "" || val == null) return;
      this.farmsLoading = true;
      FarmService.searchFarms(val)
        .then((res) => {
          console.log(res);
          this.farmsList = res.data.farms;
        })
        .catch((err) => {
          console.log(err);
          // this.users = [];
        })
        .finally(() => (this.farmsLoading = false));
    },
    searchUser(val) {
      if (val == "" || val == null) return;
      this.userLoading = true;
      FarmService.searchUsers(val)
        .then((res) => {
          console.log(res);
          this.userList = res.data.users;
        })
        .catch((err) => {
          console.log(err);
          // this.users = [];
        })
        .finally(() => (this.userLoading = false));
    },
    async getCalvedata() {
      this.startLoading();
      console.log(this.farm);
      await HealthReport.getCalves(this.farm, this.owner)
        .then((res) => {
          this.calf = res.data;
          console.log(this.calf);
          this.stopLoading();
        })
        .catch((err) => {
          console.log(err);
          this.stopLoading();
        });
    },
    async getCalvedaily() {
      this.startLoading();
      await HealthReport.getCalvedaily(
        this.startDate,
        this.endDate,
        this.farm,
        this.owner
      )
        .then(async (res) => {
          console.log(res.data);
          this.result = res.data;
          if(this.result.length>0){
          await res.data.reverse().forEach((c) => {
            if (c.gender == "female") {
              this.chartData.datasets[0].data.push(c.count);
            } else {
              this.chartData.datasets[1].data.push(c.count);
            }
          });

          this.chartData.labels =[...new Set(res.data.map((item) => item.createdAt))];
          console.log( this.chartData.labels)
          this.loaded = true;
          }
          this.stopLoading();
        })
        .catch((err) => {
          console.log(err);
          this.stopLoading();
        });
    },
        async getCalveweekly() {
      this.startLoading();
      await HealthReport.getCalveweekly(
        this.startDateWeekly,
        this.endDateWeekly,
        this.farm,
        this.owner
      )
        .then(async (res) => {
          console.log("hello",res.data);
           if(res.data.dailyRows.length>0 || res.data.weeklyRows.length>0){
          await res.data.dailyRows.reverse().forEach((c) => {
              this.data.datasets[1].data.push(c.count);
          });
           await res.data.weeklyRows.reverse().forEach((c) => {
              this.data.datasets[0].data.push(c.count);
          });
          
          if(res.data.dailyRows.length>0){
          this.data.labels =[...new Set(res.data.dailyRows.map((item) => item.createdAt))];
          console.log( this.data.labels)
          console.log( this.data.datasets)
          this.loadedWeek = true;
          }else{
            this.data.labels =[...new Set(res.data.weeklyRows.map((item) => item.data))]; 
            this.loadedWeek = true;
          }
           }
          this.stopLoading();
        })
        .catch((err) => {
          console.log(err);
          this.stopLoading();
        });
    },
    async getPregnancydata() {
      this.startLoading();
      console.log(this.farm);
      await HealthReport.getPregnancydata(this.farm, this.owner)
        .then((res) => {
          console.log("data", res);
          this.pregnantAni = res.data;
          console.log(this.pregnantAni);
          this.stopLoading();
        })
        .catch((err) => {
          console.log(err);
          this.stopLoading();
        });
    },
    async getPregnancydaily() {
      this.startLoading();
      await HealthReport.getPregnancydaily(
        this.startDate,
        this.endDate,
        this.farm,
        this.owner
      )
        .then(async (res) => {
          console.log("daily", res);
          this.result = res.data;
          if (this.result.length > 0) {
            await res.data.reverse().forEach((c) => {
              if (c.month == 0) {
                this.chartData.datasets[0].data.push(c.count);
              } else if (3 > c.month > 0) {
                this.chartData.datasets[1].data.push(c.count);
              } else if (6 > c.month > 3) {
                this.chartData.datasets[2].data.push(c.count);
              } else {
                this.chartData.datasets[3].data.push(c.count);
              }
            });

            this.chartData.labels = [
              ...new Set(res.data.map((item) => item.createdAt)),
            ];
            console.log(this.chartData.labels);
            this.loaded = true;
          }
          this.stopLoading();
        })
        .catch((err) => {
          console.log(err);
          this.stopLoading();
        });
    },
    async getPregnancyweekly() {
      this.startLoading();
      await HealthReport.getPregnancyweekly(
        this.startDateWeekly,
        this.endDateWeekly,
        this.farm,
        this.owner
      )
        .then(async (res) => {
          console.log("weekly", res.data);
          if (res.data.dailyRows.length > 0 || res.data.weeklyRows.length > 0) {
            await res.data.dailyRows.reverse().forEach((c) => {
              this.data.datasets[1].data.push(c.count);
            });
            await res.data.weeklyRows.reverse().forEach((c) => {
              this.data.datasets[0].data.push(c.count);
            });
          }
          if (res.data.dailyRows.length > 0 || res.data.weeklyRows.length > 0) {
            await res.data.dailyRows.forEach((c) => {
              this.lables.push(c.createdAt);
            });
            await res.data.weeklyRows.forEach((c) => {
              this.lables.push(c.createdAt);
            });
            this.data.labels = [...new Set(this.lables)];
            // this.data.labels =await [...new Set(res.data.dailyRows.map((item) => item.createdAt))];
            // console.log( [...this.data.labels])
            // console.log( this.data.datasets)
            // this.loadedWeek = true;
            // }
            // if(res.data.weeklyRows.length>0){
            //     this.data.labels =  [...new Set(res.data.weeklyRows.map((item) => item.createdAt))]
            this.loadedWeek = true;
          }
          this.stopLoading();
        })
        .catch((err) => {
          console.log(err);
          this.stopLoading();
        });
    },
    getPregnancyReportData() {
      this.getReportData();
    },
    getReportData() {
      this.loading = true;
      HealthReport.getPregnancyReport(
        this.farm,
        this.owner,
        this.tableOptions,
        this.search
      )
        .then((res) => {
          console.log("report", res);
          if (res.success) {
            this.anidata = res.data.pregnencyReport.rows;
            // this.currentrows = res.data.healthRecord.num_rows;
            this.totalPregnancy = res.data.pregnencyReport.total_rows.length;
            this.totalPages = Math.ceil(
              this.totalPregnancy / this.tableOptions.itemsPerPage
            );
            this.from =
              (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
            this.to =
              this.tableOptions.page * this.tableOptions.itemsPerPage -
              (this.tableOptions.itemsPerPage -
                res.data.pregnencyReport.num_rows);
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
  },
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
::v-deep .wdt {
  width: 175px;
}
.stackSheet {
  position: relative;
}
.stackSpark {
  position: absolute;
  top: 0;
  left: 0;
}
// .chart-wrapper {
//   // border: 1px solid blue;
//   height: 300px;
//   // width: 600px;
// }
</style>
